import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createFrameworkSlice } from "./slices/frameworkSlice";
import { createAccessControlSlice } from "./slices/accessControlSlice";

const useAppStore = create(
  devtools(
    (...a) => ({
      ...createFrameworkSlice(...a),
      ...createAccessControlSlice(...a),
    }),
    {
      name: "regoditStore", // For Redux DevTools
    }
  )
);

export default useAppStore;
